var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"value":_vm.value,"config":_vm.editorConfig},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }